import { Injectable } from '@angular/core';
import {DaoGeneric} from '@Services/base/daoService';
import {environment} from '@Env/environment';
import {HttpClient} from '@angular/common/http';
import {Individu} from '@Common/core/services';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IndividuService extends DaoGeneric<Individu> {
  private url = `${environment.baseUrl}/api_archive/individu/`;

  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }
  getRootUrl(urlApp?: string): string {
    return this.url;
  }
  /**
   * Recherche de demandeurs ayant déjà fait des dépôts
   * @param keyword
   * @param extraParams
   */
  searchDemandeurs(keyword: string, extraParams: Map<string, string> = null): Observable<Individu[]> {
    const url = `${this.getRootUrl()}search_demandeurs_deposits/`;
    const params = {};
    params['search'] = keyword;

    return this.httpClient.get<Individu[]>(url, {params: params});
  }
}
